import React from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { Controller, UseControllerProps } from 'react-hook-form';
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { TextFieldStyled } from './styles';

/* eslint-disable  @typescript-eslint/no-explicit-any */
export default function PasswordField({
  name,
  control,
  rules,
  defaultValue,
  ...textFieldProps
}: TextFieldProps & UseControllerProps<any>): React.ReactElement {
  const [show, setShow] = React.useState(false);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextFieldStyled
          {...field}
          {...textFieldProps}
          type={show ? 'text' : 'password'}
          margin="normal"
          autoComplete="off"
          InputProps={{
            ...textFieldProps.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  focusRipple={false}
                  aria-label="Visualizar senha"
                  onClick={() => setShow(!show)}
                >
                  {show ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          onChange={field.onChange}
          value={field.value || ''}
          error={!!error}
          helperText={error ? error.message : null}
          ref={field.ref}
        />
      )}
    />
  );
}
